export default "__VITE_ASSET__C2G4IBCN__"